<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("mall.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="form-group mg-b-15">
          <select
            class="form-control form-control-dark"
            v-model="kStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("mall.状态") }}</option>
            <option v-for="(s, k) in $dict.helpStatus" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="form-group mg-b-15">
          <select
            class="form-control form-control-dark"
            v-model="kType"
            @change="filtrate"
          >
            <option value="">{{ $t("mall.类型") }}</option>
            <option v-for="(s, k) in $dict.helpType" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("mall.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "keyStatus", "keyType"],
  data() {
    return {
      kStatus: "",
      kType: "",
    };
  },
  watch: {
    keyStatus() {
      this.kStatus = this.keyStatus;
    },
    keyType() {
      this.kType = this.keyType;
    },
  },
  methods: {
    filtrate() {
      this.$emit("filtrate", this.kStatus, this.kType);
    },
  },
  mounted() {},
  updated() {},
};
</script>